import { render, staticRenderFns } from "./gallerys.vue?vue&type=template&id=06822698&scoped=true"
import script from "./gallerys.vue?vue&type=script&lang=js"
export * from "./gallerys.vue?vue&type=script&lang=js"
import style0 from "./gallerys.vue?vue&type=style&index=0&id=06822698&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06822698",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06822698')) {
      api.createRecord('06822698', component.options)
    } else {
      api.reload('06822698', component.options)
    }
    module.hot.accept("./gallerys.vue?vue&type=template&id=06822698&scoped=true", function () {
      api.rerender('06822698', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gallery/gallerys.vue"
export default component.exports